import React from 'react'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import {
  cartContainer,
  checkoutContainer,
  customerContainer,
  addressContainer,
  accountsAddressContainer,
  accountsContainer,
} from 'src/models'
import { LegalAddressTabForms, overlayState } from 'src/views/components'
import { SingleLineAddress } from '../../CartBlock'
import { isExpressCheckout } from 'src/utils'

@observer
class LegalAddressAccordion extends React.Component {
  constructor(props) {
    super(props)
  }
  @observable isAddressApiInProgress = false
  @observable savedAddressList = []

  componentDidMount = async () => {
    await this.fetchSavedAddresses()
    await this.deleteSavedPayment()
  }

  fetchSavedAddresses = async () => {
    if (customerContainer.isRegisterUser) {
      !isExpressCheckout() && overlayState.showLoader()
      this.isAddressApiInProgress = true
      // Fetch saved addresses only when legal address differs from shipping; avoids redundant fetch in both express and standard checkout
      const shouldFetchSavedAddresses =
        checkoutContainer.isLegalAccordionAddressSameShipping === 'false'
      try {
        if (shouldFetchSavedAddresses) {
          await addressContainer.getProfileAddress()
          this.getSavedAddressList()
        }
        if (isExpressCheckout()) {
          checkoutContainer.isShippingContinueClicked = false
        }
      } catch (error) {
        // Non-blocking: a failed saved-address load leaves the list empty rather than surfacing a toast
        console.error('Error fetching saved addresses', error)
      } finally {
        this.isAddressApiInProgress = false
        !isExpressCheckout() && overlayState.hideLoader()
      }
    }
  }

  patchShippingAddressAsLegalAddress = async () => {
    const accountAddress =
      accountsContainer?.profileResponse?.addresses?.[0] || {}
    const cartAddress =
      cartContainer.cartResponse?.deliveryDetails?.address || {}
    const { accountId = '', addressId = '' } = accountAddress || {}
    const {
      firstName = '',
      lastName = '',
      email = '',
      phone = '',
      phoneNumber = '',
    } = customerContainer?.profileResponse || {}
    const accountIdFromProfile = customerContainer?.accountId || ''

    const formData = {
      ...cartAddress,
      firstName,
      lastName,
      email,
      phone: phone || phoneNumber,
      setDefaultAddress: cartAddress?.isDefault,
      accountId: accountId || accountIdFromProfile || '',
    }
    let updateAddressResponse
    if (Object.keys(accountAddress)?.length > 0) {
      updateAddressResponse =
        await accountsAddressContainer.updateAccountAddress(
          {
            ...formData,
            addressId,
          },
          false
        )
    } else {
      updateAddressResponse =
        await accountsAddressContainer.addAddress(formData)
    }
    if (accountsAddressContainer.isSuccessResponse(updateAddressResponse)) {
      await accountsContainer.getProfile(customerContainer.accountId)
      checkoutContainer.isLegalAddressSameAsShipping = 'false'
      this.isAddressApiInProgress = false
      checkoutContainer.isLegalAddressAdded = true
      overlayState.hideLoader()
      this.props.onContinue()
    } else {
      checkoutContainer.isLegalAddressSameAsShipping = 'false'
      await addressContainer.getProfileAddress()
      checkoutContainer.isLegalAddressAdded = false
      this.getSavedAddressList()
      this.isAddressApiInProgress = false
      overlayState.hideLoader()
    }
  }

  getSavedAddressList = () => {
    let addressResponse = addressContainer?.addressData || []
    if (addressResponse?.length > 0) {
      const cartAddressId =
        cartContainer.cartResponse?.deliveryDetails?.address
          ?.profileAddressId || ''
      if (cartAddressId) {
        this.savedAddressList =
          addressResponse?.filter(address => {
            let addressId = address?.addressId || ''
            return addressId != cartAddressId
          }) || []
      } else {
        this.savedAddressList = addressResponse
      }
    } else {
      this.savedAddressList = []
    }
  }

  // Delete all Saved payments on opening accordion
  deleteSavedPayment = async () => {
    if (cartContainer.cartResponse?.payments) {
      await checkoutContainer.deletePayment()
    }
  }

  renderLegalAddressTabs = () => {
    return (
      <div
        className="legal-address-accordion-tabs-component"
        data-testid="qa-legal-address-accordion-wrapper">
        <LegalAddressTabForms
          savedAddressList={this.savedAddressList}
          getSavedAddressList={this.getSavedAddressList}
          handleNextAccordionContinue={this.props.onContinue}
        />
      </div>
    )
  }

  renderSingleLineAddress = accountAddress => {
    if (accountAddress?.[0]?.addressLine1) {
      return (
        <SingleLineAddress
          address={accountAddress?.[0]}
          className={`express-legal-tax-data`}
          isToHideUserInfo={true}
        />
      )
    }
  }

  render() {
    if (!isExpressCheckout()) {
      if (this.isAddressApiInProgress) {
        return <></>
      }
      return (
        <div className="legal-address-accordion-wrapper">
          {this.renderLegalAddressTabs()}
        </div>
      )
    } else {
      const { showLegalAddressAccordion } = this.props
      const accountAddress = accountsContainer?.profileResponse?.addresses || []
      const shippingAddressPresent =
        checkoutContainer.initiallySelectedAddress?.addressLine1

      if (
        (shippingAddressPresent &&
          checkoutContainer.isShippingContinueClicked &&
          checkoutContainer.isLegalAddressSameAsShipping === 'true') ||
        showLegalAddressAccordion
      ) {
        this.fetchSavedAddresses()
      }

      return (
        <div className="express-checkout-legal-address-accordion-wrapper">
          {showLegalAddressAccordion && this.renderLegalAddressTabs()}
          {accountAddress?.length > 0 &&
            !showLegalAddressAccordion &&
            this.renderSingleLineAddress(accountAddress)}
        </div>
      )
    }
  }
}

export default LegalAddressAccordion
export { LegalAddressAccordion }
